import { render, staticRenderFns } from "./FrameworkHistory.vue?vue&type=template&id=cdee768e&"
import script from "./FrameworkHistory.vue?vue&type=script&lang=js&"
export * from "./FrameworkHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports